import { PickRecordBuilder } from "ags/integration/builders/records/pick-record-builder";
import { AgsPickSchema } from "ags/integration/schema/ags-spin-response-schema";
import { PickMatchRecord } from "slotworks/model/gameplay/records/pick-match-record";

export class ThemePickRecordBuilder extends PickRecordBuilder {
    public buildRecord(pick: AgsPickSchema, spinComplete: boolean): PickMatchRecord {
        const record = super.buildRecord(pick, spinComplete);

        const pickObj = (pick.value as any);
        if (pickObj instanceof Object && pickObj.Boost !== undefined) {
            const boostSuffix = pickObj.Boost ? "_boost" : "";
            record.value = ["mini", "minor", "major", "grand"][pickObj.Jackpot] + boostSuffix;
        }

        return record;
    }
}
